
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { CalendarDays, ClipboardList, MoreHorizontal, UtensilsCrossed } from "lucide-react";

const NavBar = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
    {
      name: "Log",
      path: "/log",
      icon: ClipboardList,
    },
    {
      name: "Meals",
      path: "/meals",
      icon: UtensilsCrossed,
    },
    {
      name: "History",
      path: "/calendar",
      icon: CalendarDays,
    },

    {
      name: "More",
      path: "/more",
      icon: MoreHorizontal,
      // Sub-pages reached from the More list should still show it as active
      matches: (path: string) => ["/more", "/fasting", "/friends", "/settings"].includes(path),
    }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white shadow-lg rounded-t-xl border-t border-gray-100 z-50">
      <div className="flex justify-around items-center h-16 max-w-md mx-auto">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={cn(
              "flex flex-col items-center justify-center flex-1 h-full transition-colors",
              (item.matches ? item.matches(currentPath) : currentPath === item.path)
                ? "text-wellness-primary"
                : "text-gray-500 hover:text-wellness-secondary"
            )}
          >
            <item.icon className="h-5 w-5 mb-1" />
            <span className="text-xs font-medium">{item.name}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default NavBar;
